import { buildStyleFns } from '../buildStyleFns';
export const borderLineStyleFnConfigs = [
    {
        name: 'borderCollapse',
        properties: ['borderCollapse'],
        system: 'none',
    },
    {
        name: 'borderSpacing',
        properties: ['borderSpacing'],
        system: 'none',
    },
    {
        name: 'borderStyle',
        properties: ['borderStyle'],
        system: 'none',
    },
    {
        name: 'borderTopStyle',
        properties: ['borderTopStyle'],
        system: 'none',
    },
    {
        name: 'borderRightStyle',
        properties: ['borderRightStyle'],
        system: 'none',
    },
    {
        name: 'borderBottomStyle',
        properties: ['borderBottomStyle'],
        system: 'none',
    },
    {
        name: 'borderLeftStyle',
        properties: ['borderLeftStyle'],
        system: 'none',
    },
    {
        name: 'borderInlineStartStyle',
        properties: ['borderInlineStartStyle'],
        system: 'none',
    },
    {
        name: 'borderInlineEndStyle',
        properties: ['borderInlineEndStyle'],
        system: 'none',
    },
];
export const borderLineStyleFns = buildStyleFns(borderLineStyleFnConfigs);
